import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';
import Spinner from '../../../../components/Widgets/spinner';
import GenericSelection from '../../../Common/GenericSelection';
import { Selection, SelectionWithProps } from '../../../Common/selection';

const createDialogStyle = {
  width: "550px",
  height: "350px",
  marginLeft: "-15%",
};

const convertPOToSOAPI = (poIds, data, success, failed) => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/purchase/convert_sales_order/${poIds} `,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    alert('SUCCESS!')
    success();
  }).catch(err => {
    alert(JSON.stringify(err));
    failed();
    // if (err.data) {
    //   alert(JSON.stringify(err.data))
    // } else {
    //   alert(JSON.stringify(err));
    // }
  });
}

const modalStyle = {
  width: '500px',
  height: '280px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class ConvertToSOModal extends React.Component {
  state = {
    selectedCustomer: null,
    ShippingAddressId: null,
    isLoading: false,
  }
  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isVisible && this.props.isVisible) {
      this.setState({
        selectedCustomer: null,
        ShippingAddressId: null,
      })
      this.props.fetchCustomers(() => { }, this.props.selectedCompany && this.props.selectedCompany.value);
    }
  }

  onConfirm = _.debounce(() => {
    this.setState({
      isLoading: true,
    })
    const payload = {
      ShippingAddressId: this.state.ShippingAddressId,
      WarehouseId: this.props.selectedWarehouse.value
    };
    const success = () => {
      this.props.setVisibility();
    }
    const failed = () => {
      this.setState({
        isLoading: false,
      })
    }
    convertPOToSOAPI(this.props.selectedRows[0].PurchaseOrder_id, payload, success, failed);
  }, 200)

  generateCustomerOptions = () => {
    const customerOptions = [];
    if (this.props.customers) {
      _.forEach(this.props.customers, customer => {
        customerOptions.push({
          label: customer.Name,
          value: customer.Customer_id,
        })
      })
    }
    return customerOptions;
  }

  generateShippingOptions = () => {
    const shippingOptions = [];
    if (this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
      _.forEach(this.props.salesShippingCustomerDetails.Shipping, shipping => {
        shippingOptions.push({
          label: shipping.AddressName,
          value: shipping.CustomerDetail_id,
        })
      })
    }
    return shippingOptions;
  }

  fetchCustomerDetails = (value) => {
    this.setState({
      selectedCustomer: value,
      ShippingAddressId: null,
    })
    this.props.fetchSalesCustomerDetail(value, false, true);
  }

  render() {
    const {
      isVisible,
      setVisibility,
      selectedRows,
    } = this.props;
    return (<SkyLightStateless
      dialogStyles={createDialogStyle}
      isVisible={isVisible}
      onCloseClicked={() => {
        setVisibility(false);
        // this.closeConfirmQuote();
      }}
      title={'Convert PO To SO'}
    >
      <Row className="centerStyle">
        <h4>
          <Translate value="msg_assign_customer" />
        </h4>
      </Row>
      <Row className="centerStyle">
        <div style={{ width: "350px" }} className="convertToSOModalInput">
          <GenericSelection
            setSelected={({ value }) => {
              this.fetchCustomerDetails(value)
            }}
            value={this.state.selectedCustomer}
            options={this.generateCustomerOptions()}
          />
        </div>
      </Row>
      <Row className="centerStyle">
        <h4>
          <Translate value="shipping_address" />:
        </h4>
      </Row>
      <Row className="centerStyle">
        <div style={{ width: "350px" }} className="convertToSOModalInput">
          <GenericSelection
            setSelected={({ value }) => this.setState({ ShippingAddressId: value })}
            value={this.state.ShippingAddressId}
            options={this.generateShippingOptions()}
          />
        </div>
      </Row>
      <br />
      <br />
      <Row className="centerStyle">
        <h4>
          <Translate value="msg_confirm_po_convert_so" />
        </h4>
      </Row>
      <ButtonToolbar className="button-toolbar-center">
        <Button
          bsStyle="danger"
          onClick={() => setVisibility(false)}
          type="button"
        >
          <Translate value="no" />
        </Button>
        <Button
          bsStyle="success"
          disabled={!this.state.ShippingAddressId || this.state.isLoading}
          onClick={() => {
            this.onConfirm();
          }}
          type="button"
        >
          {this.state.isLoading ? "Submitting...." : <Translate value="yes" />}
        </Button>
      </ButtonToolbar>
    </SkyLightStateless>)
  }
}


ConvertToSOModal.propTypes = propTypes
ConvertToSOModal.defaultProps = defaultProps

export default ConvertToSOModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/purchaseManagement/ConvertToSOModal.jsx